import { useConstant } from '../../utils/use-constant.mjs';
import { useUnmountEffect } from '../../utils/use-unmount-effect.mjs';
import { createScopedAnimate } from '../animate.mjs';

function useAnimate() {
  var scope = useConstant(function () {
    return {
      current: null,
      animations: []
    };
  });
  var animate = useConstant(function () {
    return createScopedAnimate(scope);
  });
  useUnmountEffect(function () {
    scope.animations.forEach(function (animation) {
      return animation.stop();
    });
  });
  return [scope, animate];
}

export { useAnimate };